/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import { NavLink } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";

import pdf from "../../../../icons/pdf.png";
import print from "../../../../icons/print.png";
import excel from "../../../../icons/excel.png";
import { header } from "../../../../components/api/Header";
import { monthName } from "../../../../components/functions/Month";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, PrintElem } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";

function Table1({ date, setOmbor }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const setSearch = (text) => {
    $("tbody tr.data-tr").each(function () {
      if (
        $(this)
          .children(".fix-with")[0]
          .innerText.toUpperCase()
          .indexOf(text.toUpperCase()) > -1
      ) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
      if (text != "") {
        $("tbody tr.j-tr").css("display", "none");
      } else {
        $("tbody tr.j-tr").css("display", "");
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/suvombor/table1?date=" +
            date,
          header()
        );
        if (res) {
          setData(res.data);
        }
      } catch (e) {
        console.log("Xato", e);
        alert("Bazaga bog'lanishda xato");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  let sums1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  let sums2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => PrintElem(".table")}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <NavLink
              to={
                `${getEnv('REACT_APP_BASE_URL')}/export/mpdf?sana=` +
                date +
                "&table=suvombor1"
              }
              className='btn p-0'>
              <img src={pdf} alt='404' />
            </NavLink>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Suv omborlari jadval1", date, "so1")}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead' id='tableFlexible'>
        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <table className='table table-bordered table-style' id='so1'>
            <thead>
              <tr>
                <th rowSpan={3} scope='col'>
                  N
                </th>

                <th rowSpan={3} scope='col'>
                  Suv Omborlar nomi
                </th>

                <th colSpan={7} scope='col'>
                  Hajmi (mln.m3)
                </th>

                <th rowSpan={2} colSpan={2} scope='col'>
                  Kelishi, m3/sek
                </th>

                <th rowSpan={2} colSpan={4} scope='col'>
                  Chiqishi, m3/sek oldingi yillar shu kunga
                </th>
              </tr>

              <tr>
                <th rowSpan={2} scope='col'>
                  Loyiha bo’yicha
                </th>

                <th colSpan={2} scope='col'>
                  Amalda
                </th>

                <th rowSpan={2} scope='col'>
                  Ishlatib bo’lmaydi
                </th>

                <th colSpan={3} scope='col'>
                  Oldingi yillar shu kunga
                </th>
              </tr>

              <tr>
                <th scope='col'>
                  {date.slice(8, 10) - 1} {monthName(date)}
                </th>
                <th scope='col'>
                  {date.slice(8, 10)} {monthName(date)}
                </th>
                <th scope='col'>{date.slice(0, 4) - 1}</th>
                <th scope='col'>{date.slice(0, 4) - 2}</th>
                <th scope='col'>{date.slice(0, 4) - 3}</th>
                <th scope='col'>{date.slice(0, 4) - 1}</th>
                <th scope='col'>{date.slice(0, 4)}</th>
                <th scope='col'>{date.slice(0, 4)}</th>
                <th scope='col'>{date.slice(0, 4) - 1}</th>
                <th scope='col'>{date.slice(0, 4) - 2}</th>
                <th scope='col'>{date.slice(0, 4) - 3}</th>
              </tr>
            </thead>

            <tbody></tbody>
            {data.length > 0
              ? data.map((d, index) => {
                  if (index === 0) {
                    sums1 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                    sums2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
                  }
                  sums1[0] = qosh(sums1[0], d.loyiha_boyicha);
                  sums1[1] = qosh(sums1[1], d.data1);
                  sums1[2] = qosh(sums1[2], d.data2);
                  sums1[3] = qosh(sums1[3], d.data3);
                  sums1[4] = qosh(sums1[4], d.data4);
                  sums1[5] = qosh(sums1[5], d.data5);
                  sums1[6] = qosh(sums1[6], d.data6);
                  sums1[7] = qosh(sums1[7], d.data7);
                  sums1[8] = qosh(sums1[8], d.data8);
                  sums1[9] = qosh(sums1[9], d.data9);
                  sums1[10] = qosh(sums1[10], d.data10);
                  sums1[11] = qosh(sums1[11], d.data11);
                  sums1[12] = qosh(sums1[12], d.data12);
                  if (index > 30) {
                    sums2[0] = qosh(sums2[0], d.loyiha_boyicha);
                    sums2[1] = qosh(sums2[1], d.data1);
                    sums2[2] = qosh(sums2[2], d.data2);
                    sums2[3] = qosh(sums2[3], d.data3);
                    sums2[4] = qosh(sums2[4], d.data4);
                    sums2[5] = qosh(sums2[5], d.data5);
                    sums2[6] = qosh(sums2[6], d.data6);
                    sums2[7] = qosh(sums2[7], d.data7);
                    sums2[8] = qosh(sums2[8], d.data8);
                    sums2[9] = qosh(sums2[9], d.data9);
                    sums2[10] = qosh(sums2[10], d.data10);
                    sums2[11] = qosh(sums2[11], d.data11);
                    sums2[12] = qosh(sums2[12], d.data12);
                  }
                  return (
                    <tbody key={index}>
                      {/*{*/}
                      {/*    index === 26 ? <tr className="j-tr"><td></td><td>shu jumladan</td></tr>:null*/}
                      {/*}*/}
                      <tr className='data-tr'>
                        <td>{index + 1}</td>
                        <td className='text-start fix-with'>
                          <NavLink
                            style={{
                              color: "#25213b",
                            }}
                            to={"/suvomborlari/" + d.id}
                            onClick={() =>
                              setOmbor({
                                nomi: d.nomi,
                                location: [d.lat, d.lan],
                              })
                            }>
                            {d.nomi}
                          </NavLink>
                        </td>
                        <td>{d.loyiha_boyicha}</td>
                        <td>{d.data1}</td>
                        <td>{d.data2}</td>
                        <td>{d.data3}</td>
                        <td>{d.data4}</td>
                        <td>{d.data5}</td>
                        <td>{d.data6}</td>
                        <td>{d.data7}</td>
                        <td>{d.data8}</td>
                        <td>{d.data9}</td>
                        <td>{d.data10}</td>
                        <td>{d.data11}</td>
                        <td>{d.data12}</td>
                      </tr>
                      {/*{*/}
                      {/*    index === 30 ?*/}
                      {/*        <>*/}
                      {/*            <tr className="j-tr">*/}
                      {/*                <td colSpan={2}>Jami</td>*/}
                      {/*                {sums1.map((s,i)=>{*/}
                      {/*                    return <td key={i}>{s}</td>*/}
                      {/*                })}*/}
                      {/*            </tr>*/}
                      {/*            <tr className="table-one-row j-tr">*/}
                      {/*                <td colSpan={15}>Respublikalararo</td>*/}
                      {/*            </tr>*/}
                      {/*        </>*/}

                      {/*        :null*/}
                      {/*}*/}
                      {/*{*/}
                      {/*    index === 35 ?*/}
                      {/*        <>*/}
                      {/*            <tr className="j-tr">*/}
                      {/*                <td colSpan={2}>Jami</td>*/}
                      {/*                {sums2.map((s,i)=>{*/}
                      {/*                    return <td key={i}>{s}</td>*/}
                      {/*                })}*/}
                      {/*            </tr>*/}
                      {/*            <tr className="j-tr">*/}
                      {/*                <td colSpan={2}>Hammasi</td>*/}
                      {/*                {sums1.map((s,i)=>{*/}
                      {/*                    return <td key={i}>{s}</td>*/}
                      {/*                })}*/}
                      {/*            </tr>*/}
                      {/*        </>:null*/}
                      {/*}*/}
                    </tbody>
                  );
                })
              : null}
          </table>
        )}
      </div>
    </>
  );
}

export default Table1;

const qosh = (a, b) => {
  if (!a || a === "undefined" || typeof a === "undefined") {
    a = 0;
  }
  if (!b || b === "undefined" || typeof b === "undefined") {
    b = 0;
  }
  let s = parseFloat(a) + parseFloat(b);
  if (s % 1 !== 0) return s.toFixed(2);
  return s;
};
